export default __webpack_public_path__ + "static/media/mission.1f0c1c30.svg";